angular.module('bmsApp').service('APIInterceptor', function ($rootScope, LastError, $location) {
    var service = this;

    service.responseError = function (response) {
        if (response.status === 401) {

            // $rootScope.$broadcast('logout');
            //$rootScope.$broadcast('401_unauthorised');
            //$rootScope.errorStatus = response.status;
            //$rootScope.isError = true;
        }
        else if (response.status === 403) {
            $rootScope.$broadcast('403_forbidden');
            $rootScope.errorStatus = response.status;
            $rootScope.isError = true;
        }
        else if (response.status === 404) {
            $rootScope.$broadcast('404');
            $rootScope.errorStatus = response.status;
            $rootScope.isError = true;
        }
        else if (response.status == 500 || response.status == 405) {
            $rootScope.errorResponse = response.data;
            $rootScope.errorStatus = response.status;
            $rootScope.isError = true;
            $rootScope.$broadcast('500');
        }

        return response;
    };
});